import type { AxiosInstance } from 'axios';
import type { User } from '@/types';
import baseAxios from '@/helpers/forms/axios';

interface UserApi {
    fetchCurrentUser: () => Promise<User>
    markAnnouncementsAsRead: () => Promise<void>
}

export default (axios: AxiosInstance = baseAxios): UserApi => ({
    fetchCurrentUser: async (): Promise<User> => {
        const response = await axios.get<User>('/user/current');
        return response.data;
    },
    markAnnouncementsAsRead: async (): Promise<void> => {
        await axios.put('/user/last-read-announcements-at');
    },
});
